<template>
  <section id="service" class="section service">
    <div class="container">
      <div class="service__head">
        <div class="section-head" v-reveal>
          <span class="eyebrow">02 / Service</span>
          <h2 class="section-title">
            <span class="en">Service</span>
            サービス
          </h2>
        </div>
        <p class="service__lead" v-reveal="80">
          構想の相談から、開発、そして運用保守まで。バックエンドエンジニアリングを土台に、生成AIとAI駆動開発を組み合わせて、Webサービスづくりを一貫してご支援します。
        </p>
      </div>

      <div class="service__grid">
        <!-- 01 -->
        <article class="card" v-reveal="60">
          <div class="card__top">
            <span class="card__idx">01</span>
            <span class="card__icon" aria-hidden="true">
              <svg viewBox="0 0 32 32" width="30" height="30">
                <path d="M16 4l2.4 6.8L25 13l-6.6 2.2L16 22l-2.4-6.8L7 13l6.6-2.2z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
                <path d="M25 20l.9 2.6L28.5 24l-2.6.9L25 27.5l-.9-2.6L21.5 24l2.6-.9z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" />
              </svg>
            </span>
          </div>
          <p class="card__en">Generative AI &amp; AI Agent Development</p>
          <h3 class="card__title">生成AI導入支援・AIエージェント開発</h3>
          <p class="card__body">
            「業務にAIを取り入れたいが、何から始めればいいか分からない」——そんな段階からご相談ください。生成AIを使った業務効率化、社内データを参照して回答するAIチャット（RAG）、定型業務を自律的にこなすAIエージェントの開発まで。まずは小さく試すPoC（試作・検証）から始め、効果を確かめながら育てていく進め方をおすすめしています。
          </p>
        </article>

        <!-- 02 -->
        <article class="card" v-reveal="140">
          <div class="card__top">
            <span class="card__idx">02</span>
            <span class="card__icon" aria-hidden="true">
              <svg viewBox="0 0 32 32" width="30" height="30">
                <path d="M11 10L5 16l6 6M21 10l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18 6l-4 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              </svg>
            </span>
          </div>
          <p class="card__en">Web Application Development</p>
          <h3 class="card__title">AI駆動開発による受託開発</h3>
          <p class="card__body">
            SaaSやAPIなど、Webサービスのプログラム開発に幅広く対応します。近年は Claude Code をはじめとするAIコーディング支援ツールを開発に取り入れ、これまでより短い期間で形にできるようになりました。ただし、AIが生成したコードはそのまま採用せず、人の目によるレビューと自動テストを必ず通します。速さと品質、その両方を大切にした開発をお約束します。
          </p>
        </article>

        <!-- 03 -->
        <article class="card" v-reveal="60">
          <div class="card__top">
            <span class="card__idx">03</span>
            <span class="card__icon" aria-hidden="true">
              <svg viewBox="0 0 32 32" width="30" height="30">
                <rect x="5" y="6" width="22" height="7" rx="2" fill="none" stroke="currentColor" stroke-width="1.6" />
                <rect x="5" y="19" width="22" height="7" rx="2" fill="none" stroke="currentColor" stroke-width="1.6" />
                <circle cx="10" cy="9.5" r="1.2" fill="currentColor" />
                <circle cx="10" cy="22.5" r="1.2" fill="currentColor" />
                <path d="M17 9.5h6M17 22.5h6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
              </svg>
            </span>
          </div>
          <p class="card__en">Infrastructure &amp; Operations</p>
          <h3 class="card__title">インフラ構築・運用保守・サーバー監視</h3>
          <p class="card__body">
            自社サーバーやクラウドを問わず、お客様のWebサービスに最適なインフラ環境を構築します。公開後も、サイトが正常に動いているかを常時監視し、障害が発生した際には迅速に復旧対応。「つくって終わり」ではなく、安定して動き続けることまでを含めてご支援します。
          </p>
        </article>

        <!-- 04 -->
        <article class="card" v-reveal="140">
          <div class="card__top">
            <span class="card__idx">04</span>
            <span class="card__icon" aria-hidden="true">
              <svg viewBox="0 0 32 32" width="30" height="30">
                <circle cx="8" cy="9" r="3" fill="none" stroke="currentColor" stroke-width="1.6" />
                <circle cx="24" cy="9" r="3" fill="none" stroke="currentColor" stroke-width="1.6" />
                <circle cx="16" cy="23" r="3" fill="none" stroke="currentColor" stroke-width="1.6" />
                <path d="M8 12v3a3 3 0 0 0 3 3h2m13-6v3a3 3 0 0 1-3 3h-2" fill="none" stroke="currentColor" stroke-width="1.6" />
                <path d="M16 12v8" fill="none" stroke="currentColor" stroke-width="1.6" />
              </svg>
            </span>
          </div>
          <p class="card__en">Direction &amp; Technical Consulting</p>
          <h3 class="card__title">開発ディレクション・技術支援・コンサルティング</h3>
          <p class="card__body">
            Webサービス開発の計画づくり（リソースとスケジュールの設計）から、Web制作会社様の開発体制に対する課題分析・改善提案、そのクライアント様からの技術的なお問い合わせへの対応まで。開発の「進め方」と「体制」の面から、プロジェクトを支えます。生成AIをどう業務に取り入れるかといった、技術面のご相談にも対応します。
          </p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServiceSection',
}
</script>

<style scoped lang="scss">
.service {
  border-top: 1px solid var(--line);
}

.service__head {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: end;
}

.service__lead {
  max-width: 46ch;
  font-size: clamp(1rem, 1.3vw, 1.1rem);
  line-height: 1.9;
  color: var(--ink-soft);
}

.service__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: clamp(44px, 6vw, 72px);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: clamp(28px, 3vw, 40px);
  background: var(--paper-raised);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: transform 0.4s var(--ease), box-shadow 0.4s var(--ease),
    border-color 0.4s var(--ease);
}

.card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 3px;
  background: var(--accent);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.45s var(--ease);
}

.card:hover {
  transform: translateY(-6px);
  border-color: var(--accent-line);
  box-shadow: 0 40px 70px -50px rgba(83, 48, 27, 0.55);
}

.card:hover::before {
  transform: scaleX(1);
}

.card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.card__idx {
  font-family: var(--font-mono);
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  color: var(--faint);
}

.card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  color: var(--accent);
  background: var(--accent-mist);
  border-radius: 12px;
  transition: transform 0.4s var(--ease);
}

.card:hover .card__icon {
  transform: scale(1.06) rotate(-3deg);
}

.card__en {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 10px;
}

.card__title {
  font-family: var(--font-jp);
  font-weight: 700;
  font-size: clamp(1.15rem, 1.9vw, 1.42rem);
  line-height: 1.4;
  color: var(--ink);
  margin-bottom: 16px;
}

.card__body {
  font-size: 0.94rem;
  line-height: 1.9;
  color: var(--ink-soft);
}

@media (max-width: 760px) {
  .service__head {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .service__grid {
    grid-template-columns: 1fr;
  }
}
</style>
